const appmtOverlay = document.querySelector('.appmt-overlay');
const appmtModal = document.querySelector('.appmt-modal');
const appmtModalLocation = document.querySelector('.appmt-modal-location');
const appmtselectedStore = document.querySelectorAll('.selected-store');
const appmtCurrentMonth = document.querySelector('.appmt-current-month');
const appmtDateSelector = document.querySelector('.appmt-date-select');
const appmtNextButton = document.querySelector('.appmt-next-btn');
const appmtModalFinal = document.querySelector('.appmt-modal-final');
const appmtModalSuccess = document.querySelector('.appmt-modal-success');
const appmtBusyMsg = document.querySelector('.appmt-busy-msg');
const appmtDateError = document.querySelector('.appmt-date-error');
const appmtpurposeError = document.querySelector('.appmt-purpose-error');
const locationInput = document.querySelector('.location-input');
const detectLocation = document.querySelector('.detect-location');
const changeLocation = document.querySelector('.change-location');
const noStoreSearch = document.querySelector('.appmt-no-store-search');
const noStore = document.querySelector('.appmt-no-store-pincode');
const appmtShimmer = document.querySelector('.appmt-shimmer-container');
const appmtNumError = document.querySelector('.appmt-number-error');
const callStore = document.querySelectorAll('.show-all-stores .ct_store_call');
const mapStore = document.querySelectorAll('.show-all-stores .ct_store_map');

const appmtDetails = {
    customerName: "",
    phoneNumber: "",
    emailId: "",
    storePhone: "",
    storeMap: "",
    visitTime: "",
    visitDay: "",
    formatDay: "",
    visitDate: "",
    purpose: "",
    storeName: "",
    storeId: "",
};

const today = new Date();
appmtNextButton?.setAttribute('disabled', 'true');

// Function to handle pincode input
function handleInput(event) {
    const inputElement = event.target;
    let inputValue = inputElement.value.trim();
    const isPincode = /^\d+$/.test(inputValue); // Check if input contains only digits
    const maxLength = 6;
    const noStoreDescription = noStore?.querySelector('.no-store-description');

    // Handle empty input
    if (inputValue === '') {
        detectLocation.style.display = 'block';
        changeLocation.style.display = 'none';
        if (noStore) noStore.style.display = 'none';
        if (noStoreSearch) noStoreSearch.style.display = 'none';
        return;
    }

    if (isPincode) {
        // Restrict to maxLength digits
        if (inputValue.length > maxLength) {
            inputElement.value = inputValue.slice(0, maxLength);
            return;
        }

        if (inputValue.length < maxLength) {
            // Hide "no store" message for incomplete pincode
            if (noStore) noStore.style.display = 'none';
            return;
        }

        // If exactly 6 digits, fetch store data
        if (inputValue.length === maxLength) {
            inputElement.setAttribute('data-editable', 'false'); // Prevent new input except backspace

            const data = {
                pin: Number(inputValue),
                method_call: 'pin_location',
            };

            // AJAX call to fetch location data
            $.ajax({
                type: 'POST',
                url: 'https://gifting.kushals.com/location_api/location.php',
                data: data,
                cache: false,
                success: (response) => {
                    try {
                        const parsedResponse = JSON.parse(response);

                        if (parsedResponse.status && parsedResponse.store) {
                            if (noStore) noStore.style.display = 'none';
                            if (noStoreSearch) noStoreSearch.style.display = 'none';
                            // Store found
                            appmtShimmer.style.display = 'flex';
                            pin_check(Number(inputValue));

                            // Push event to Clevertap
                            clevertap.event.push("search_pincode", {
                                "pin_code": inputValue,
                            });
                        } else {
                            // No store found
                            if (noStoreDescription) {
                                noStoreDescription.innerHTML =
                                    `Looks like there aren't any stores in “${inputValue}”. Try searching in different areas.`;
                                noStore.style.display = 'flex';
                                if (noStoreSearch) noStoreSearch.style.display = 'none';
                            }
                        }
                    } catch (error) {
                        console.error('Error parsing response:', error);
                    }
                },
                error: (error) => {
                    console.error('Error fetching location data:', error);
                },
            });

            // Update UI after entering a valid pincode
            detectLocation.style.display = 'none';
            changeLocation.style.display = 'block';
        }
    } else {
        // Handle non-numeric input (filter stores by search keyword)
        filterStores(inputValue);
    }
}

// Enable backspace but prevent new input
function handleKeyDown(event) {
    const inputElement = event.target;

    if (inputElement.getAttribute('data-editable') === 'false') {
        if (event.key === 'Backspace') {
            inputElement.removeAttribute('data-editable'); // Allow edits again
        } else {
            event.preventDefault(); // Prevent new numbers/alphabets
        }
    }
}

// Ensure cursor appears and allow backspacing
function handleFocus(event) {
    const inputElement = event.target;
    inputElement.removeAttribute('data-editable'); // Allow backspacing but not new input
}

locationInput?.addEventListener('input', handleInput);
locationInput?.addEventListener('keydown', handleKeyDown);
locationInput?.addEventListener('focus', handleFocus);


// Filter Functionality
function filterStores(searchInput) {
    if (noStore) noStore.style.display = 'none';
    const storeBoxes = document.querySelectorAll('.appmt-modal .store-more-box');
    let noStoreSearchText = document.querySelector('.no-store-description');
    let hasVisibleStores = false; // To track if any store is visible

    storeBoxes.forEach(storeBox => {
        const storeName = storeBox.querySelector('.store-more-name span')?.textContent.toLowerCase() || '';
        const storeText = storeBox.querySelector('.store-more-text')?.textContent.toLowerCase() || '';

        if (storeName.includes(searchInput.toLowerCase()) || storeText.includes(searchInput.toLowerCase())) {
            storeBox.style.display = 'block';
            hasVisibleStores = true;
        } else {
            storeBox.style.display = 'none';
        }
    });

    // Show or hide the "No Stores" message and adjust store display
    if (noStoreSearch) {
        if (!hasVisibleStores) {
            noStoreSearch.style.display = 'flex';
            noStoreSearchText.innerHTML =  `Looks like there aren't any stores in “${searchInput}”. Try searching in different areas.`
            storeBoxes.forEach(storeBox => {
                storeBox.style.display = 'block'; // Make all store boxes visible
            });
        } else {
            noStoreSearch.style.display = 'none';
        }
    }
}

function getLocationDetection() {
    if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
            (position) => {
                appmtShimmer.style.display = 'flex';
                // User allowed location access
                setTimeout(() => {
                    const pin = localStorage.getItem('pin');
                    if (pin) {
                        locationInput.value = pin;
                        clevertap.event.push("pin_detected", {
                            "pin_detected": pin,
                        });
                    } else {
                        console.log('No pin found in localStorage.');
                    }
                }, 5000);
                showPosition(position);
            },
            (error) => {
                // User denied location access or an error occurred
                if (error.code === error.PERMISSION_DENIED) {
                    console.error("User denied location access.");
                } else {
                    console.error("Error occurred: ", error.message);
                }
                showError("Please allow Location Access");
            }
        );
    } else {
        console.error("Geolocation is not supported by this browser.");
    }    
}

function changeInputValue() {
    if (locationInput) {
        locationInput.removeAttribute('readonly');
        locationInput.value = '';
        detectLocation.style.display = 'block';
        changeLocation.style.display = 'none';
    }

    const storeBoxes = document.querySelectorAll('.appmt-modal .store-more-box');

    storeBoxes.forEach(storeBox => {
            storeBox.style.display = 'block';
    });

    if (noStoreSearch) {
        noStoreSearch.style.display = 'none';
    }

    if (noStore) {
        noStore.style.display = 'none';
    }
}

// Modal open/close functions
function appointModalOpen(event) {
    const button = event.currentTarget;
    const pageTitle = button.getAttribute('data-pageTitle');
    const productName = button.getAttribute('data-product');
    appmtOverlay?.classList.add('show');
    appmtModal.classList.add('show');
    document.body.classList.add('mm-no-scroll');

    const locationStore = JSON.parse(localStorage.getItem('location_store'));
    let postal = '';
    let city = '';
    if (locationStore) {
        postal = locationStore.postal || '';
        city = locationStore.city || '';
    }

    // Push event to Clevertap
    clevertap.event.push("book_appointment_click", {
        "page_title": pageTitle || '',
        "product_name": productName || '',
        "default_pinCode": postal,
        "default_city": city,
    });
}

function resetAppointmentErrorState() {
    const nameInput = document.querySelector('.appmt-input-name');
    const emailInput = document.querySelector('.appmt-input-email');
    const phoneInput = document.querySelector('.appmt-input-num');
    const phoneContainer = document.querySelector('.appmt-number-container');
    const errorContainer = document.querySelector('.appmt-error-container');

    if (nameInput) {
        nameInput.classList.remove('appmt-input-warning', 'shake');
    }
    if (emailInput) {
        emailInput.classList.remove('appmt-input-warning', 'shake');
    }
    if (phoneInput) {
        phoneInput.classList.remove('appmt-input-warning', 'shake');
    }
    if (phoneContainer) {
        phoneContainer.classList.remove('shake');
    }
    if (appmtDateError) {
        appmtDateError.style.display = 'none';
    }
    if (appmtpurposeError) {
        appmtpurposeError.style.display = 'none';
    }
    if (appmtNumError) {
        appmtNumError.style.display = 'none';
    }
    if (errorContainer) {
        errorContainer.classList.remove('show');
    }
    if (appmtBusyMsg) {
        appmtBusyMsg.style.display = 'none';
    }
}

function appointModalClose() {
    const purposeElement = document.querySelector('.appmt-purpose.active');
    appmtNextButton?.setAttribute('disabled', 'true');

    if(locationInput){
        locationInput.value = "";
        locationInput.removeAttribute('readonly');
    }
    if(purposeElement) {
        purposeElement.classList.remove('active');
    }
    document.querySelectorAll('.appmt-purpose').forEach((purpose) => purpose.classList.remove('active'));

    if (noStore) {
        noStore.style.display = 'none';
    }
    if (noStoreSearch) {
        noStoreSearch.style.display = 'none';
    }

    if(appmtDateSelector){
        appmtDateSelector.querySelectorAll('.time-slot').forEach(s => {
            s.classList.remove('active');
            s.classList.add('not-selected');
        });
    }

    // Synchronous reset before any hide/show transitions.
    resetAppointmentErrorState();
    appmtModal.classList.add('hide');
    appmtModalLocation.classList.add('hide');
    appmtModalFinal.classList.add('hide');
    appmtDateSelector.querySelectorAll('.time-slot').forEach(s => s.classList.remove('active'));

    setTimeout(() => {
        appmtOverlay.classList.remove('show');
        appmtModal.classList.remove('show', 'hide');
        appmtModalLocation.classList.remove('show', 'hide');
        appmtModalFinal.classList.remove('show', 'hide');
        document.body.classList.remove('mm-no-scroll');
        appmtModalSuccess.classList.remove('show');
    }, 400);
}

// Handle Book Appointment button click
function handleAppointmentAction(button) {
    const buttonText = button.textContent.trim();
    const buttonParent = button.closest('.appmt-store-box');
    const storeName = buttonParent.querySelector('.store-more-name span')?.textContent || buttonParent.querySelector('.store_box_header span')?.textContent;

    if (buttonText === 'Book Appointment') {
        switchToLocationModal(buttonParent);
        // Push event to Clevertap
        clevertap.event.push("book_appointment_modal", {
            "store_name": storeName,
        });

    } else if (buttonText === 'View Appointment') {
        switchToViewModal(buttonParent);
    } else {
        console.error('Unexpected button text:', buttonText);
    }


}

function switchToViewModal(parentElement) {
    let storeIdParent = Number(parentElement.dataset.storeId);

    if (storeIdParent) {
        const storageKey = 'storeVisitData';
        const storedData = JSON.parse(localStorage.getItem(storageKey)) || [];
        let childElement = parentElement.querySelector('.store_pro-link.ct_store_click') || parentElement.querySelector('.ct_click_wrap.ct_store_click');;

        // Find all store data with the matching storeId
        const matchingStores = storedData.filter(item => item.storeId === storeIdParent);

        // Use the last matching store
        const store = matchingStores[matchingStores.length - 1];

        if (store) {
            // Remove existing timings
            const existingTimings = document.querySelectorAll('.appmt-visit-timings');
            existingTimings?.forEach(timing => timing.remove());

            // Format visit day and date
            let visitFormatDay = store.visitDay.charAt(0).toUpperCase() + store.visitDay.slice(1, 3).toLowerCase();
            const date = new Date(store.visitDate);
            const options = { year: 'numeric', month: 'short', day: 'numeric' };
            const visitFormatDate = date.toLocaleDateString('en-US', options);

            // Create and append a new div with the timings
            let div = document.createElement('div');
            div.classList.add('appmt-visit-timings');
            div.innerHTML = `
                <span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path d="M10.1468 8.04522L7.31329 10.8787L5.85378 9.41872C5.80766 9.37097 5.75249 9.33288 5.69149 9.30667C5.63049 9.28047 5.56488 9.26667 5.49849 9.2661C5.4321 9.26552 5.36626 9.27817 5.30481 9.30331C5.24336 9.32845 5.18753 9.36558 5.14059 9.41252C5.09364 9.45947 5.05651 9.5153 5.03137 9.57674C5.00623 9.63819 4.99358 9.70403 4.99416 9.77042C4.99474 9.83681 5.00853 9.90242 5.03473 9.96342C5.06094 10.0244 5.09903 10.0796 5.14679 10.1257L6.95978 11.9392C7.00611 11.9858 7.06119 12.0228 7.12186 12.048C7.18252 12.0733 7.24758 12.0862 7.31329 12.0862C7.37899 12.0862 7.44404 12.0733 7.50471 12.048C7.56538 12.0228 7.62046 11.9858 7.66679 11.9392L10.8538 8.75222C10.9015 8.7061 10.9396 8.65093 10.9658 8.58992C10.992 8.52892 11.0058 8.46331 11.0064 8.39692C11.007 8.33053 10.9943 8.26469 10.9692 8.20324C10.9441 8.1418 10.9069 8.08597 10.86 8.03903C10.813 7.99208 10.7572 7.95495 10.6958 7.92981C10.6343 7.90467 10.5685 7.89202 10.5021 7.8926C10.4357 7.89317 10.3701 7.90697 10.3091 7.93317C10.2481 7.95938 10.1929 7.99747 10.1468 8.04522Z" fill="#454545"/>
                        <path d="M12.5 1.98H11.75V1.5C11.75 1.36739 11.6973 1.24021 11.6036 1.14645C11.5098 1.05268 11.3826 1 11.25 1C11.1174 1 10.9902 1.05268 10.8964 1.14645C10.8027 1.24021 10.75 1.36739 10.75 1.5V1.98H5.25V1.5C5.25 1.36739 5.19732 1.24021 5.10355 1.14645C5.00979 1.05268 4.88261 1 4.75 1C4.61739 1 4.49021 1.05268 4.39645 1.14645C4.30268 1.24021 4.25 1.36739 4.25 1.5V1.98H3.5C2.1215 1.98 1 3.1015 1 4.48V12.5C1 13.8785 2.1215 15 3.5 15H12.5C13.8785 15 15 13.8785 15 12.5V4.48C15 3.1015 13.8785 1.98 12.5 1.98ZM2 4.48C2 3.653 2.673 2.98 3.5 2.98H4.25V3.46C4.25 3.59261 4.30268 3.71979 4.39645 3.81355C4.49021 3.90732 4.61739 3.96 4.75 3.96C4.88261 3.96 5.00979 3.90732 5.10355 3.81355C5.19732 3.71979 5.25 3.59261 5.25 3.46V2.98H10.75V3.46C10.75 3.59261 10.8027 3.71979 10.8964 3.81355C10.9902 3.90732 11.1174 3.96 11.25 3.96C11.3826 3.96 11.5098 3.90732 11.6036 3.81355C11.6973 3.71979 11.75 3.59261 11.75 3.46V2.98H12.5C13.327 2.98 14 3.653 14 4.48V4.985H2V4.48ZM12.5 14H3.5C2.673 14 2 13.327 2 12.5V5.985H14V12.5C14 13.327 13.327 14 12.5 14Z" fill="#454545"/>
                    </svg>
                </span>
                <p>${visitFormatDay}, ${visitFormatDate}</p>
                <p>${store.time}</p>
            `;
            childElement.appendChild(div);

            // Update Booking ID
            const storeId = document.querySelector('.appmt-store-id');
            if (storeId) {
                storeId.innerHTML = `Booking ID : ${store.bookingId}`;
            }
        }
    }

    const bookAnotherAppmt = document.querySelector('.appmt-modal-success .book-another-appmt');
    if (!appmtOverlay.classList.contains('show')) {
        document.body.classList.add('mm-no-scroll');
        appmtOverlay.classList.add('show');
        appmtModalSuccess.classList.add('show');
        bookAnotherAppmt.style.display = 'block';
    } else {
        appointModalClose();
        setTimeout(() => {
            document.body.classList.add('mm-no-scroll');
            appmtOverlay.classList.add('show');
            appmtModalSuccess.classList.add('show');
            bookAnotherAppmt.style.display = 'block';
        }, 1000);
    }

    bookAnotherAppmt.addEventListener('click', (e) => {
        bookAnotherAppmtBtn(parentElement);
    });

    const observeDOMChanges = () => {
        const observer = new MutationObserver((mutationsList) => {
            for (const mutation of mutationsList) {
                if (mutation.type === 'childList') {
                    const callSuccessIcon = document.querySelector('.selected-store-success .call-icon');
                    if (callSuccessIcon) {
                        callSuccessIcon.innerHTML = `
                            <img src="https://cdn.shopify.com/s/files/1/0796/1959/files/fluent_call-28-regular_30874d9f-ed9a-431a-aee5-67ea2bede1f1.png?v=1721645944" alt="">
                        `;
                        // Stop observing once the element is found and updated
                        observer.disconnect();
                        break;
                    }
                }
            }
        });
    
        // Start observing the body or a specific parent element
        observer.observe(document.body, { childList: true, subtree: true });
    };
    
    // Call the function to start observing
    observeDOMChanges();
    

    appmtselectedStore.forEach((el) => {
        el.innerHTML = parentElement.innerHTML;
    });
}


function bookAnotherAppmtBtn(parentElement) {
    appmtModalSuccess.classList.remove('show');
    switchToLocationModal(parentElement);
}

// Switch between modals
function switchToLocationModal(parentElement) {
    if (!appmtOverlay.classList.contains('show')) {
        document.body.classList.add('mm-no-scroll');
        appmtOverlay.classList.add('show');
    }

    let storeId = parentElement.dataset.storeId;
    appmtDetails.storeId = storeId;
    const storeName = parentElement.querySelector('.store-more-name span')?.textContent || '';
    appmtDetails.storeName = storeName;

    storeTimingsApi(storeId);
    appmtselectedStore.forEach((el) => {
        el.innerHTML = parentElement.innerHTML;
    });
    appmtModalLocation.classList.add('show');
}

function switchToappmtModal() {
    // Synchronous reset before switching modal state.
    resetAppointmentErrorState();
    setTimeout(() => {
        appmtModal.classList.add('show');
        appmtModalLocation.classList.remove('show');
        appmtDateSelector.querySelectorAll('.time-slot').forEach(s => {
            s.classList.remove('active');
            s.classList.add('not-selected');
        });
    }, 400);

    // Push event to Clevertap
    clevertap.event.push("change_store", {
        "store_name": appmtDetails.storeName,
        "date": appmtDetails.visitDate,
        "time": appmtDetails.visitTime,
    });
}


// Function to show the final modal
function switchToFinalModal() {
    const existingTimings = document.querySelectorAll('.appmt-visit-timings');
    existingTimings.forEach(timing => timing.remove());

    let visitFormatDay = appmtDetails.visitDay.charAt(0).toUpperCase() + appmtDetails.visitDay.slice(1, 3).toLowerCase();
    const date = new Date(appmtDetails.visitDate);
    const options = { year: 'numeric', month: 'short', day: 'numeric' };
    const visitFormatDate = date.toLocaleDateString('en-US', options);

    let div = document.createElement('div');
    div.classList.add('appmt-visit-timings');
    div.innerHTML = `
    <span>
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M10.1468 8.04522L7.31329 10.8787L5.85378 9.41872C5.80766 9.37097 5.75249 9.33288 5.69149 9.30667C5.63049 9.28047 5.56488 9.26667 5.49849 9.2661C5.4321 9.26552 5.36626 9.27817 5.30481 9.30331C5.24336 9.32845 5.18753 9.36558 5.14059 9.41252C5.09364 9.45947 5.05651 9.5153 5.03137 9.57674C5.00623 9.63819 4.99358 9.70403 4.99416 9.77042C4.99474 9.83681 5.00853 9.90242 5.03473 9.96342C5.06094 10.0244 5.09903 10.0796 5.14679 10.1257L6.95978 11.9392C7.00611 11.9858 7.06119 12.0228 7.12186 12.048C7.18252 12.0733 7.24758 12.0862 7.31329 12.0862C7.37899 12.0862 7.44404 12.0733 7.50471 12.048C7.56538 12.0228 7.62046 11.9858 7.66679 11.9392L10.8538 8.75222C10.9015 8.7061 10.9396 8.65093 10.9658 8.58992C10.992 8.52892 11.0058 8.46331 11.0064 8.39692C11.007 8.33053 10.9943 8.26469 10.9692 8.20324C10.9441 8.1418 10.9069 8.08597 10.86 8.03903C10.813 7.99208 10.7572 7.95495 10.6958 7.92981C10.6343 7.90467 10.5685 7.89202 10.5021 7.8926C10.4357 7.89317 10.3701 7.90697 10.3091 7.93317C10.2481 7.95938 10.1929 7.99747 10.1468 8.04522Z" fill="#454545"/>
            <path d="M12.5 1.98H11.75V1.5C11.75 1.36739 11.6973 1.24021 11.6036 1.14645C11.5098 1.05268 11.3826 1 11.25 1C11.1174 1 10.9902 1.05268 10.8964 1.14645C10.8027 1.24021 10.75 1.36739 10.75 1.5V1.98H5.25V1.5C5.25 1.36739 5.19732 1.24021 5.10355 1.14645C5.00979 1.05268 4.88261 1 4.75 1C4.61739 1 4.49021 1.05268 4.39645 1.14645C4.30268 1.24021 4.25 1.36739 4.25 1.5V1.98H3.5C2.1215 1.98 1 3.1015 1 4.48V12.5C1 13.8785 2.1215 15 3.5 15H12.5C13.8785 15 15 13.8785 15 12.5V4.48C15 3.1015 13.8785 1.98 12.5 1.98ZM2 4.48C2 3.653 2.673 2.98 3.5 2.98H4.25V3.46C4.25 3.59261 4.30268 3.71979 4.39645 3.81355C4.49021 3.90732 4.61739 3.96 4.75 3.96C4.88261 3.96 5.00979 3.90732 5.10355 3.81355C5.19732 3.71979 5.25 3.59261 5.25 3.46V2.98H10.75V3.46C10.75 3.59261 10.8027 3.71979 10.8964 3.81355C10.9902 3.90732 11.1174 3.96 11.25 3.96C11.3826 3.96 11.5098 3.90732 11.6036 3.81355C11.6973 3.71979 11.75 3.59261 11.75 3.46V2.98H12.5C13.327 2.98 14 3.653 14 4.48V4.985H2V4.48ZM12.5 14H3.5C2.673 14 2 13.327 2 12.5V5.985H14V12.5C14 13.327 13.327 14 12.5 14Z" fill="#454545"/>
        </svg>
    </span>
    <p>${visitFormatDay}, ${visitFormatDate}</p>
    <p>${appmtDetails.visitTime}</p>`;

    let checkImage = document.createElement('span');
    checkImage.classList.add('check-image');
    checkImage.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
            <circle cx="16.0001" cy="16.0005" r="11.4286" fill="white"/>
            <path d="M16 0C20.2435 0 24.3131 1.68571 27.3137 4.68629C30.3143 7.68687 32 11.7565 32 16C32 20.2435 30.3143 24.3131 27.3137 27.3137C24.3131 30.3143 20.2435 32 16 32C11.7565 32 7.68687 30.3143 4.68629 27.3137C1.68571 24.3131 0 20.2435 0 16C0 11.7565 1.68571 7.68687 4.68629 4.68629C7.68687 1.68571 11.7565 0 16 0ZM14.0069 19.1566L10.4526 15.6C10.3252 15.4726 10.1739 15.3715 10.0074 15.3025C9.84092 15.2336 9.66249 15.1981 9.48229 15.1981C9.30209 15.1981 9.12365 15.2336 8.95717 15.3025C8.79069 15.3715 8.63942 15.4726 8.512 15.6C8.25466 15.8573 8.1101 16.2064 8.1101 16.5703C8.1101 16.9342 8.25466 17.2832 8.512 17.5406L13.0377 22.0663C13.1648 22.1943 13.3159 22.296 13.4825 22.3653C13.649 22.4347 13.8276 22.4704 14.008 22.4704C14.1884 22.4704 14.367 22.4347 14.5335 22.3653C14.7001 22.296 14.8512 22.1943 14.9783 22.0663L24.3497 12.6926C24.4788 12.5657 24.5816 12.4145 24.652 12.2477C24.7223 12.0809 24.759 11.9018 24.7599 11.7208C24.7607 11.5398 24.7257 11.3603 24.6569 11.1929C24.588 11.0255 24.4867 10.8733 24.3588 10.7452C24.2308 10.6172 24.0788 10.5157 23.9114 10.4466C23.7441 10.3776 23.5647 10.3424 23.3837 10.343C23.2027 10.3436 23.0235 10.3801 22.8567 10.4503C22.6898 10.5205 22.5385 10.623 22.4114 10.752L14.0069 19.1566Z" fill="#28BE7F"/>
        </svg>`;

    let referenceElements = document.querySelectorAll('.selected-store-final .ct_store_click');
    if (referenceElements.length > 0) {
        referenceElements.forEach((ele) => {
            ele.insertAdjacentElement('afterend', div.cloneNode(true));
            ele.insertAdjacentElement('afterend', checkImage.cloneNode(true));
        });
    }

    // Push event to Clevertap
    clevertap.event.push("date_time_appmt", {
        "store_name": appmtDetails.storeName,
        "date": appmtDetails.visitDate,
        "time": appmtDetails.visitTime,
    });

    appmtModalFinal.classList.add('show');
}


// Function to go back to the location modal from the final modal
function backToLocationModal() {
    // Synchronous reset before returning to location modal.
    resetAppointmentErrorState();
    setTimeout(() => {
        appmtModalFinal.classList.remove('show');
    }, 200);
}

// Function to show the final modal
function switchToSuccessModal(bookingId) {
    const bookAnotherAppmt = document.querySelector('.appmt-modal-success .book-another-appmt');
    let callSuccessIcon = document.querySelector('.selected-store-success .call-icon');
    bookAnotherAppmt.style.display = 'none';
    if(callSuccessIcon) {
        callSuccessIcon.innerHTML = `
            <img src="https://cdn.shopify.com/s/files/1/0796/1959/files/fluent_call-28-regular_30874d9f-ed9a-431a-aee5-67ea2bede1f1.png?v=1721645944" alt="">
        `
    }
    setTimeout(() => {
        appmtOverlay?.classList.add('show');
        document.body.classList.add('mm-no-scroll');
        appmtModalSuccess.classList.add('show');
    }, 1000);

    let storePhone = appmtDetails.storePhone.replace('tel:', '');
    function formatDate(dateString) {
      const date = new Date(dateString);
    
      if (isNaN(date)) {
        console.error('Invalid date format');
        return '';
      }
    
      const day = date.getDate();
      const month = date.toLocaleString('en-US', { month: 'short' });
    
      // Add ordinal suffix (st, nd, rd, th)
      const suffix =
        day === 1 || day === 21 || day === 31 ? 'st' :
        day === 2 || day === 22 ? 'nd' :
        day === 3 || day === 23 ? 'rd' : 'th';
      return `${day}${suffix} ${month}`;
    }
    
    let formattedDate = formatDate(appmtDetails.visitDate);

    clevertap.profile.push({
        "Site": {
          "Name": appmtDetails.customerName,
          "Phone": `+91${appmtDetails.phoneNumber}`,
          "Email": appmtDetails.emailId,
       // optional fields. controls whether the user will be sent email, push etc.
          "MSG-email": false,
          "MSG-push": true,
          "MSG-sms": true,
          "MSG-whatsapp": true,
        }
       });
    
    // Push event to Clevertap
    clevertap.event.push("appmt_success", {
        "customer_name": appmtDetails.customerName,
        "store_name": appmtDetails.storeName,
        "phone_number": appmtDetails.phoneNumber,
        "customer_email": appmtDetails.emailId,
        "date": formattedDate,
        "storePhone": storePhone,
        "storeMap": appmtDetails.storeMap,
        "time": appmtDetails.visitTime,
        "booking_id": bookingId,
        "purpose": appmtDetails.purpose,
    });
}

// Function to go back to the location modal from the final modal
function backToFinalModal() {
    setTimeout(() => {
        appmtModalSuccess.classList.remove('show');
    }, 200);
}

// Fetch store timings and render schedule
async function storeTimingsApi(storeId) {
    try {
        const response = await fetch(`${window.apiUrl}/store-visit/timing`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
        const storeTimings = await response.json();
        renderWeeklySchedule(storeTimings.weeklySchedule, storeId);
    } catch (error) {
        console.error('Error fetching store timings:', error);
    }
}

function validateNumber(inputElement) {
    let value = inputElement.value.replace(/\D/g, ''); // Remove any non-numeric characters
    if (value.length > 10) {
        value = value.slice(0, 10); // Restrict to 10 digits
    }
    inputElement.value = value; 

    const customerNum = document.querySelector('.appmt-input-num');
    if (value.length === 10) {
        if (customerNum.classList.contains('appmt-input-warning')) {
            customerNum.classList.remove('appmt-input-warning');
        }
    }
}

if(appmtDateSelector){
    appmtDateSelector.addEventListener('click', (event) => {
        if (event.target.classList.contains('time-slot') && event.target.classList.contains('not-selected')) {
            appmtDateError.style.display = 'inline';
        }
    });
}


function validateName() {
    const customerName = document.querySelector('.appmt-input-name');
    if (customerName.classList.contains('appmt-input-warning')) {
        customerName.classList.remove('appmt-input-warning');
    }
}

function validateEmail() {
    const customerEmail = document.querySelector('.appmt-input-email');
    const emailValue = customerEmail.value.trim();

    if (customerEmail.classList.contains('appmt-input-warning')) {
        customerEmail.classList.remove('appmt-input-warning');
    }

    // Check if email contains '@' and '.com'
    const isValidEmail = emailValue.includes('@') && emailValue.includes('.com');

    if (isValidEmail) {
        customerEmail.classList.remove('appmt-input-warning');
    }
}

// Appointment API
async function postStoreVisitAPI() {
    const customerNameInput = document.querySelector('.appmt-input-name');
    const customerNameEmail = document.querySelector('.appmt-input-email');
    const phoneNumberInput = document.querySelector('.appmt-input-num');
    const phoneNumberContainer = document.querySelector('.appmt-number-container');
    const purposeElement = document.querySelector('.appmt-purpose.active');
    const storeIdElement = document.querySelector('.appmt-store-id');
    const storeCallElement = document.querySelector('.selected-store-final .ct_store_call');
    const storeMapElement = document.querySelector('.selected-store-final .ct_store_map');
    const storePhone = storeCallElement ? storeCallElement.href : null;
    const storeMapLink = storeMapElement ? storeMapElement.href : null;
    const customerName = customerNameInput.value.trim();
    const customerEmail = customerNameEmail.value.trim();
    const phoneNumber = phoneNumberInput.value.trim();
    const isValidEmail = customerEmail.includes('@') && customerEmail.includes('.com');
    const purpose = purposeElement ? purposeElement.textContent.trim() : '';
    const isValidPhoneNumber = /^\d{10}$/.test(phoneNumber);
    const storageKey = 'storeVisitData';

    // Input validation
    if (!customerName || !phoneNumber || phoneNumber.length < 10 || !isValidPhoneNumber || !purpose || !customerEmail || !isValidEmail ) {
        if (!customerName) {
            customerNameInput.classList.add('appmt-input-warning', 'shake');
            setTimeout(() => customerNameInput.classList.remove('shake'), 500);
        }

        if(!customerEmail) {
            customerNameEmail.classList.add('appmt-input-warning', 'shake');
            setTimeout(() => customerNameEmail.classList.remove('shake'), 500);
        }

        if(!isValidEmail) {
            customerNameEmail.classList.add('appmt-input-warning', 'shake');
            setTimeout(() => customerNameEmail.classList.remove('shake'), 500);
        }

        if (!phoneNumber || phoneNumber.length < 10 || !isValidPhoneNumber) {
            phoneNumberInput.classList.add('appmt-input-warning');
            phoneNumberContainer.classList.add('shake');
            setTimeout(() => phoneNumberContainer.classList.remove('shake'), 500);
        }
        
        if (!purpose) {
            appmtpurposeError.style.display = 'inline';
        }

        if (navigator.vibrate) {
            navigator.vibrate(100);
        }

        return;
    }

    // Close modal and reset UI
    appmtModal.classList.add('hide');
    appmtModalLocation.classList.add('hide');
    appmtModalFinal.classList.add('hide');
    appmtDateSelector.querySelectorAll('.time-slot').forEach(s => s.classList.remove('active'));

    setTimeout(() => {
        appmtOverlay.classList.remove('show');
        appmtModal.classList.remove('show', 'hide');
        appmtModalLocation.classList.remove('show', 'hide');
        appmtModalFinal.classList.remove('show', 'hide');
        document.body.classList.remove('mm-no-scroll');
    }, 400);

    // Store appointment details
    appmtDetails.customerName = customerName;
    appmtDetails.phoneNumber = phoneNumber;
    appmtDetails.purpose = purpose;
    appmtDetails.storePhone = storePhone;
    appmtDetails.storeMap = storeMapLink;
    appmtDetails.emailId = customerEmail;

    const url = `${window.apiUrl}/store-visit`;
    const data = {
        customerName: appmtDetails.customerName,
        phoneNumber: appmtDetails.phoneNumber,
        emailId: appmtDetails.emailId,
        time: appmtDetails.visitTime,
        visitDate: appmtDetails.visitDate,
        purpose: appmtDetails.purpose,
        storeId: Number(appmtDetails.storeId),
        sourceType: "appointment"
    };

    try {
        const storedData = JSON.parse(localStorage.getItem(storageKey)) || [];

        const options = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data)
        };

        const response = await fetch(url, options);
        const responseData = await response.json();

        if (!response.ok) {
            showError('Please try again later');
            console.error(`API error: ${responseData.message || response.statusText}`);
        } else {

            const localStorageStore = {
                customerName: appmtDetails.customerName,
                phoneNumber: appmtDetails.phoneNumber,
                customerEmail: appmtDetails.emailId,
                bookingId: responseData.id,
                visitDay: appmtDetails.visitDay,
                time: appmtDetails.visitTime,
                visitDate: appmtDetails.visitDate,
                purpose: appmtDetails.purpose,
                storeId: Number(appmtDetails.storeId)
            };

            storedData.push(localStorageStore);

            // Update local storage with the new array
            localStorage.setItem(storageKey, JSON.stringify(storedData));

            appmtOverlay?.classList.add('show');
            document.body.classList.add('mm-no-scroll');
            updateStoreButtons();
            
            storeIdElement.innerHTML = `Booking ID : ${responseData.id}`;
            switchToSuccessModal(responseData.id);
        }
    } catch (error) {
        showError('Please try again later');
        console.error('Error hitting the API:', error);
    }
}

// Function to update store buttons on page load and after booking
function updateStoreButtons() {
    const storageKey = 'storeVisitData';
    let storedData = [];

    try {
        storedData = JSON.parse(localStorage.getItem(storageKey)) || [];
    } catch (e) {
        storedData = [];
    }

    const latestBookingByStore = new Map();
    storedData.forEach((booking) => {
        if (booking && booking.storeId != null) {
            latestBookingByStore.set(String(booking.storeId), booking);
        }
    });

    const allStores = document.querySelectorAll('.appmt-store-box[data-store-id]');
    allStores.forEach((ele) => {
        const thisStore = String(ele.getAttribute('data-store-id') || '');
        const bookButton = ele.querySelector('.book-appmt-button');
        if (!bookButton) return;

        if (latestBookingByStore.has(thisStore)) {
            bookButton.textContent = 'View Appointment';
        } else {
            bookButton.textContent = 'Book Appointment';
        }
    });
}

function runStoreButtonSyncWithRetries() {
    const retryDelays = [0, 300, 1000, 2000, 4000, 7000];
    retryDelays.forEach((delay) => {
        setTimeout(updateStoreButtons, delay);
    });
}

// Ensure store buttons update on page load and after async store render.
document.addEventListener('DOMContentLoaded', runStoreButtonSyncWithRetries);
document.addEventListener('storeLocator:storesRendered', runStoreButtonSyncWithRetries);



// Render weekly schedule
function renderWeeklySchedule(weeklySchedule, storeId) {
    const appmtWeekSelector = document.querySelector('.appmt-current-week');
    const weekHTML = weeklySchedule.map((schedule, index) => {
        const dayDate = new Date(today);
        dayDate.setDate(today.getDate() + index);
        const formattedDate = dayDate.getDate();
        const dateAPI = dayDate.toLocaleDateString('en-CA');
        const day = index === 0 ? 'Today' : schedule.day.substring(0, 1).toUpperCase() + schedule.day.substring(1, 3).toLowerCase();
        return `
            <p class="appmt-days-container" data-day="${schedule.day}" data-date="${formattedDate}" data-api="${dateAPI}">
                <span class="appmt-day-text">${day}</span>
                <span class="appmt-date">${formattedDate}</span>
            </p>
        `;
    }).join("");

    appmtWeekSelector.innerHTML = weekHTML;
    appmtCurrentMonth.innerHTML = today.toLocaleString('default', { month: 'short', year: 'numeric' });
    addActiveClassToButtons(weeklySchedule, storeId);
}

// Add active class to buttons
function addActiveClassToButtons(weeklySchedule, storeId) {
    const appmtDaysContainers = document.querySelectorAll('.appmt-days-container');
    appmtDaysContainers.forEach((button) => {
        button.addEventListener('click', (event) => {
            appmtDaysContainers.forEach((btn) => btn.classList.remove('active'));
            appmtBusyMsg.style.display = 'none';
            appmtDateError.style.display = 'none';
            const selectedDay = event.currentTarget.getAttribute('data-day');
            const selectedDate = event.currentTarget.getAttribute('data-date');
            const selectedDateAPI = event.currentTarget.getAttribute('data-api');
            appmtDetails.visitDay = selectedDay;
            appmtDetails.visitDate = selectedDateAPI;
            event.currentTarget.classList.add('active');

            displayTimeSlotsForSelectedDay(selectedDay, weeklySchedule, selectedDate, storeId);
        });
    });
}

// Display time slots for the selected day
function displayTimeSlotsForSelectedDay(selectedDay, weeklySchedule, selectedDate, storeId) {
    const storageKey = 'storeVisitData';
    const storedData = JSON.parse(localStorage.getItem(storageKey)) || [];
    const matchingStores = storedData.filter(item => {
        return item.storeId == storeId;
    });
    
    // Extract visitDate and time from matchingStores
    const visitDetails = matchingStores.map(store => ({
        visitDate: store.visitDate.split('-')[2], // Extract only the date part (e.g., "30")
        time: store.time // Extract the time (e.g., "03:00 PM")
    }));

    let Pramod = false; // Initialize as false
    const selectedDateDoubleDigit = String(selectedDate).padStart(2, '0'); // Ensure selectedDate is in double digits

    // Find the schedule for the selected day
    const selectedDaySchedule = weeklySchedule.find(schedule => schedule.day === selectedDay);

    if (selectedDaySchedule?.timeSlots?.length) {
        // Extract time slots for the selected day
        const timeSlots = selectedDaySchedule.timeSlots.map(slot => slot.time);

        // Check if any matching store has the same date and time as the selected day's time slots
        for (const detail of visitDetails) {
            if (detail.visitDate === selectedDateDoubleDigit && timeSlots.includes(detail.time)) {
                Pramod = true; // Set to true if both conditions are met
                break; // Exit the loop early since we found a match
            }
        }
    }

    // Rest of your code for rendering time slots
    appmtDateSelector.innerHTML = '';
    appmtNextButton?.setAttribute('disabled', 'true');
    const todayDate = today.getDate();
    const selectedDayNumber = Number(selectedDate);
    const currentTime = new Date();
    const parseTime = (time, day) => {
        const [hours, minutes] = time.match(/\d+/g).map(Number);
        const isPM = time.includes('PM');
        const parsedDate = new Date(day);
        if (isPM) {
            parsedDate.setHours(hours === 12 ? 12 : hours + 12, minutes, 0);
        } else {
            parsedDate.setHours(hours === 12 ? 0 : hours, minutes, 0);
        }
        return parsedDate;
    };

    if (selectedDaySchedule?.timeSlots?.length) {
        const limitedTimeSlots = selectedDaySchedule.timeSlots.slice(0, 9);
        const slotsHTML = limitedTimeSlots.map(timeSlot => {
            const isDisabled = selectedDayNumber === todayDate && parseTime(timeSlot.time, today) < currentTime;
            
            // Check if the current time slot is booked
            const isBooked = visitDetails.some(detail => 
                detail.visitDate === selectedDateDoubleDigit && detail.time === timeSlot.time
            );
    
            return `
                <span class="time-slot ${isDisabled ? 'disabled' : ''} ${isBooked ? 'isBooked' : ''}">
                    ${timeSlot.time}
                </span>
            `;
        }).join("");
    
        appmtDateSelector.innerHTML = slotsHTML;

        // Event Delegation for Disabled/Booked/Not-Selected Slots
        appmtDateSelector.addEventListener('click', (event) => {
            if (event.target.classList.contains('time-slot') && 
                (event.target.classList.contains('disabled') || 
                event.target.classList.contains('not-selected') || 
                event.target.classList.contains('isBooked'))) {
                return; // Prevent further execution
            }

            if (event.target.classList.contains('time-slot')) {
                // Remove 'active' class from all slots
                appmtDateSelector.querySelectorAll('.time-slot').forEach(s => s.classList.remove('active'));

                // Add 'active' class to selected slot
                event.target.classList.add('active');
                appmtNextButton?.removeAttribute('disabled');

                // Extract visit time
                let visitTime = event.target.textContent.trim();
                appmtDetails.visitTime = visitTime;
                let date = new Date('01/01/1970 ' + visitTime);
                let hour = date.getHours();
                let parsedSlotTime = hour % 12 || 12;  // Convert to 12-hour format, ensuring 12 PM is 12, not 0

                const isWeekend = ['FRIDAY', 'SATURDAY', 'SUNDAY'].includes(selectedDay.toUpperCase());
                const isAfternoon = parsedSlotTime >= 5 && parsedSlotTime <= 7;

                if (isWeekend && isAfternoon) {
                    appmtBusyMsg.style.display = 'flex';
                    appmtBusyMsg.scrollIntoView({
                        behavior: 'smooth',
                        block: 'center',
                    });
                } else {
                    appmtBusyMsg.style.display = 'none';
                }
            }
        });

    } else {
        appmtDateSelector.innerHTML = '<p>No available time slots</p>';
        appmtBusyMsg.style.display = 'none';
    }
}

function showError(message) {
    const errorContainer = document.querySelector('.appmt-error-container');
    const errorMessage = errorContainer.querySelector('.appmt-error-code');
    errorMessage.textContent = message;
    errorContainer.classList.add('show');
    
    setTimeout(() => {
        errorContainer.classList.remove('show');
    }, 3000);
}

// Close modal on overlay click
appmtOverlay?.addEventListener('click', (e) => {
    if (e.target === appmtOverlay) appointModalClose();
});

// Attach a click event listener to each 'appmt-purpose' element
document.querySelectorAll('.appmt-purpose').forEach((purpose) => {
    purpose.addEventListener('click', () => {
        const currentActive = document.querySelector('.appmt-purpose.active');
        if (currentActive) {
            currentActive.classList.remove('active');
        }
        purpose.classList.add('active');
        appmtpurposeError.style.display = 'none';
    });
});

// Push event to Clevertap
callStore.forEach((el) => {
    let call = el.closest('.appmt-store-box');
    let storeName = call.querySelector('.store-more-name span')?.textContent.toLowerCase() || '';
    el.addEventListener('click', () => {
        clevertap.event.push("appmt_call_store", {
            "store_name": storeName,
        });
    });
});

mapStore.forEach((el) => {
    let map = el.closest('.appmt-store-box');
    let storeName = map.querySelector('.store-more-name span')?.textContent.toLowerCase() || '';
    el.addEventListener('click', () => {
        clevertap.event.push("appmtmap_store", {
            "store_name": storeName,
        });
    });
});

const appmtImageBanner = document.querySelector('.appmt-image');

appmtImageBanner?.addEventListener('click', (event) => {
    appointModalOpen(event);
});
